import { Popover } from "@mui/material";
import React from "react";
import {
  FaCaretDown,
  FaCaretSquareLeft,
  FaCaretSquareRight,
} from "react-icons/fa";

const CustomPagination = ({
  count: totalCount,
  rowsPerPage: pageSize,
  page: currentPage,
  onPageChange,
  onRowsPerPageChange,
  RowsPerPage,
}) => {
  const pageCount = Math.ceil(totalCount / pageSize);
  const pages = Array.from({ length: pageCount }, (_, index) => index + 1);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handlePageChange = (newPage) => {
    if (newPage === "+" && currentPage < pageCount - 1) {
      onPageChange(currentPage + 1);
    } else if (newPage === "-" && currentPage >= 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handlePageSizeChange = (val) => {
    const newSize = parseInt(val, 10);
    onRowsPerPageChange(newSize);
  };

  const PerPage = [5, 10, 25];

  const visiblePages = 1;
  const startPage = Math.max(1, currentPage - visiblePages);
  const endPage = Math.min(pageCount, currentPage + visiblePages);

  return (
    <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-2 my-3 px-3 text-sm text-inkSecondary font-quicksand">
      <span className="flex justify-center items-center gap-x-1.5">
        Rows per page:
        <button
          type="button"
          aria-label="Select rows per page"
          className="flex items-center gap-1 px-2 h-8 rounded-md border border-line bg-card text-ink font-bold hover:border-main transition-colors"
          onClick={handleClick}
        >
          {RowsPerPage}
          <FaCaretDown className="text-xs" />
        </button>
      </span>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            width: "120px",
            overflow: "hidden",
            marginTop: "8px",
            boxShadow:
              "0 4px 12px rgba(16,69,70,0.08), 0 12px 28px rgba(16,69,70,0.08)",
            border: "1px solid #E5E9EB",
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="bg-white text-ink font-quicksand p-1 flex flex-col">
          {PerPage.map((page_, i) => {
            const active = page_ === RowsPerPage;
            return (
              <button
                key={i}
                type="button"
                className={`flex items-center justify-between px-3 py-2 rounded-md text-sm font-semibold transition-colors ${
                  active
                    ? "bg-brandSoft text-main"
                    : "text-inkSecondary hover:bg-subtle"
                }`}
                onClick={() => {
                  handlePageSizeChange(page_);
                  handleClose();
                }}
              >
                <span>{page_}</span>
                {active && <span className="text-main text-xs">●</span>}
              </button>
            );
          })}
        </div>
      </Popover>
      <div className="flex justify-center items-center gap-1">
        <button
          type="button"
          aria-label="Previous page"
          onClick={() => handlePageChange("-")}
          disabled={currentPage === 0}
          className="p-1.5 rounded-md text-inkSecondary hover:text-main hover:bg-subtle disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-inkSecondary transition-colors"
        >
          <FaCaretSquareLeft className="text-base" />
        </button>
        {pages.slice(startPage - 1, endPage).map((page) => {
          const active = currentPage + 1 === page;
          return (
            <button
              key={page}
              type="button"
              onClick={() => handlePageChange(page)}
              className={`min-w-[28px] h-8 px-2 rounded-md text-sm font-semibold transition-colors ${
                active
                  ? "bg-main text-white"
                  : "text-inkSecondary hover:bg-subtle"
              }`}
            >
              {page}
            </button>
          );
        })}
        <button
          type="button"
          aria-label="Next page"
          onClick={() => handlePageChange("+")}
          disabled={currentPage === pageCount - 1 || pageCount === 0}
          className="p-1.5 rounded-md text-inkSecondary hover:text-main hover:bg-subtle disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-inkSecondary transition-colors"
        >
          <FaCaretSquareRight className="text-base" />
        </button>
      </div>
    </div>
  );
};

export default CustomPagination;
